"use client";
import { clsx } from "clsx";
import { useState } from "react";
import type { ReactNode } from "react";
import { Link } from "@repo/next-utils/router";
import * as Sheet from "@repo/ui/sheet";
import { useMediaQuery } from "@repo/ui/useMediaQuery";
import { CloseIcon } from "@/theme/icons/close";
import classes from "./simple-sheet.module.css";

type SimpleSheetProps = {
  children: ReactNode;
  position: "right" | "bottom" | "center";
  trigger: ReactNode;
  triggerHref?: string;
  triggerClassName?: string;
  title?: string | ReactNode;
  description?: string;
};

export const SimpleSheet = ({
  children,
  position,
  title,
  description,
  trigger,
  triggerHref,
  triggerClassName,
}: SimpleSheetProps) => {
  const [open, setOpen] = useState(false);
  const prefersReducedMotion = useMediaQuery(
    "(prefers-reduced-motion: reduce)",
  );
  return (
    <Sheet.Root open={open} onOpenChange={setOpen}>
      <Sheet.Title className={classes.hidden}>{title}</Sheet.Title>
      <Sheet.Description className={classes.hidden}>
        {description}
      </Sheet.Description>
      <Sheet.Trigger
        className={clsx(classes.trigger, triggerClassName)}
        asChild={!!triggerHref}
        onClick={(event) => {
          setOpen(true);
          event.preventDefault();
        }}
      >
        {triggerHref ? <Link href={triggerHref}>{trigger}</Link> : trigger}
      </Sheet.Trigger>

      <Sheet.Content
        position={position}
        overlayAnimation={!prefersReducedMotion}
        className={clsx(
          classes.content,
          position === "right" && classes.contentRight,
        )}
      >
        <div className={classes.header}>
          <Sheet.Close className={clsx(classes.close)}>
            <CloseIcon>Close</CloseIcon>
          </Sheet.Close>
        </div>
        <Sheet.Main className={classes.main}>{children}</Sheet.Main>
      </Sheet.Content>
    </Sheet.Root>
  );
};
